var map = {
	"./de_DE.json": 1064,
	"./en_AU.json": 1065,
	"./en_CA.json": 1066,
	"./en_GB.json": 1067,
	"./es_AR.json": 1068,
	"./es_ES.json": 1069,
	"./es_MX.json": 1070,
	"./fr_CA.json": 1071,
	"./fr_FR.json": 1072,
	"./it_IT.json": 1073,
	"./nl_NL.json": 1074,
	"./pt_BR.json": 1075,
	"./pt_PT.json": 1076
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1063;